export const getQuery = () => {
    return new URLSearchParams(window.location.search);
}

export const getLandingId = () => {
    const landingId = window.location.pathname.replace('/landing/', '');
    let newLandingId = landingId.split('/');
    if (newLandingId.length > 1){
        return typeof Number(newLandingId[0]) === "number" ? newLandingId[0] : null
    }

    return typeof Number(landingId) === "number" ? landingId : null
}

export const getGETParametersString = () => {
    return window.location.search.trim()
}

export const clearUrlFromGETParamaters = () => {
    const GETParametersString = getGETParametersString(),
          clearUrl = window.location.pathname.replace(GETParametersString, ''),
          title = document.title

    window.history.pushState("", title, clearUrl);
}